import { Component, HostListener, input, output } from '@angular/core';
import { AdesaoLog } from '../../core/models/integracao.model';
import { DataTableComponent } from '../../shared/components/data-table/data-table.component';
import { StatusBadgeComponent } from '../../shared/components/status-badge/status-badge.component';

/**
 * Log de um participante. Diferente do log da integração (que resume a carga inteira), aqui o
 * que importa é o histórico da adesão e, sobretudo, a mensagem que explica cada status — é ela
 * que diz por que uma integração falhou.
 */
@Component({
  selector: 'app-adesao-log-dialog',
  imports: [DataTableComponent, StatusBadgeComponent],
  templateUrl: './adesao-log-dialog.component.html',
  styleUrl: './adesao-log-dialog.component.scss',
})
export class AdesaoLogDialogComponent {
  readonly log = input.required<AdesaoLog>();

  readonly fechar = output<void>();

  onFechar(): void {
    this.fechar.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onFechar();
  }
}
